import { render } from "./EntitiesTab.vue?vue&type=template&id=9137dcea"
import script from "./EntitiesTab.vue?vue&type=script&lang=js"
export * from "./EntitiesTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__